import { z } from "zod";
import {
    InvoiceColumn,
    InvoiceLineItemColumn,
    InvoicesByCustomerColumn,
} from "../../../types/views/invoiceViews";

export const invoiceExportColumnSchema = z.union([
    z.nativeEnum(InvoiceColumn),
    z.nativeEnum(InvoiceLineItemColumn),
    z.nativeEnum(InvoicesByCustomerColumn),
    z.string().startsWith("ledgerAccount:"),
    z.string().startsWith("ledgerReceivable:"),
]);

export type InvoiceExportColumn = z.infer<typeof invoiceExportColumnSchema>;
